import React from 'react';
import './MyUXProcess.css';

function MyUXProcessPL() {
  return (
    <div className="section-container">
      {/* Main heading and subtitle */}
      <h2 className="main-heading">
        Mój proces UX <span className="heading-subtitle">Podejście</span>
      </h2>

      {/* Research Methods */}
      <h3 className="section-heading">Metody badawcze:</h3>
      <ul className="process-list">
        <li>
          Przeprowadzałam pogłębione <strong>interviews</strong> z użytkownikami, aby pozyskać insights
        </li>
        <li>
          <strong>Benchmarking</strong> konkurencji
        </li>
        <li>
          Opracowanie pytań dotyczących <strong>usability</strong>
        </li>
        <li>
          Tworzenie <strong>journey maps</strong>
        </li>
        <li>
          Pisanie <strong>user stories</strong>
        </li>
        <li>
          Projektowanie <strong>personas</strong>
        </li>
        <li>
          Testy użyteczności: <strong>A/B testing</strong>
        </li>
      </ul>

      {/* Design Techniques */}
      <h3 className="section-heading">Techniki projektowe:</h3>
      <ul className="process-list">
        <li>
          Figma – tworzenie <strong>wireframes</strong> i <strong>prototypes</strong> do iteracji rozwiązań projektowych.
        </li>
      </ul>

      {/* Testing */}
      <h3 className="section-heading">Testowanie:</h3>
      <ul className="process-list">
        <li>
          Prowadzenie <strong>usability testing</strong> w celu zbierania feedbacku i iteracji projektów.
        </li>
        <li>
          Współpraca z developers przy wdrażaniu responsywnych rozwiązań projektowych.
        </li>
      </ul>
    </div>
  );
}

export default MyUXProcessPL;